// Based on: https://github.com/nicolasbeauvais/vue-social-sharing/blob/master/src/share-network.js
class SocialShare {
    constructor(el) {
        this.networkLinks = {
            email: 'mailto:?subject=@t&body=@u%0D%0A@d',
            facebook: 'https://www.facebook.com/sharer/sharer.php?u=@u&title=@t&description=@d&quote=@q&hashtag=@h',
            linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=@u&title=@t&summary=@d',
            twitter: 'https://twitter.com/intent/tweet?text=@t&url=@u&hashtags=@h@tu',
        }
        // the url of the page we are on.
        this.src = window.location.href

        // Twitter User
        this.twitterUser = '@GentexCorp'
        // Popup window properties.
        this.popupProps = {
            width: 600,
            height: 436,
        }
        this.networks = {}
        this.popup = {
            top: 0,
            left: 0,
            window: undefined,
            interval: null,
        }

        this.buildListeners(el)
        this.buildNetworks(el)
    }

    buildListeners(el) {
        el.querySelectorAll('[data-social-share-type]').forEach(btn => {
            const type = btn.dataset.socialShareType
            btn.addEventListener('click', () => this.onClick(type))
        })
    }

    buildNetworks(el) {
        const _networks = {}

        // title of the article
        const title = el.dataset.socialShareNav || null
        // Description of the content to share.
        const description = el.dataset.socialShareDescription || null
        // Hashtags used for Facebook and Twitter. Comma seperated string
        const hashtags = el.dataset.socialShareHashtags || ""

        for (const key in this.networkLinks) {
            let link = this.networkLinks[key]

            if (key === 'twitter') {
                if (!hashtags.length) link = link.replace('&hashtags=@h', '')
                if (!this.twitterUser.length) link = link.replace('@tu', '')
            }

            _networks[key] = link
                .replace(/@tu/g, '&via=' + encodeURIComponent(this.twitterUser))
                .replace(/@u/g, encodeURIComponent(this.src))
                .replace(/@t/g, encodeURIComponent(title))
                .replace(/@d/g, encodeURIComponent(description))
                .replace(/@q/g, encodeURIComponent(this.quote))
                .replace(/@h/g, this.encodedHashtags(key, hashtags))
                .replace(/@m/g, encodeURIComponent(this.media))
        }
        return this.networks = _networks
    }

    /**
     * Center the popup on multi-screens
     * http://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen/32261263
     */
    resizePopup() {
        const width = window.innerWidth || (document.documentElement.clientWidth || window.screenX)
        const height = window.innerHeight || (document.documentElement.clientHeight || window.screenY)
        const systemZoom = width / window.screen.availWidth

        this.popup.left = (width - this.popupProps.width) / 2 / systemZoom + (window.screenLeft !== undefined ? window.screenLeft : window.screenX)
        this.popup.top = (height - this.popupProps.height) / 2 / systemZoom + (window.screenTop !== undefined ? window.screenTop : window.screenY)
    }

    encodedHashtags(network, hashtags) {
        if (network === 'facebook' && hashtags) {
            return '%23' + hashtags.replace(/\s+/g, '').split(',')[0]
        }

        return 
    }

    onClick (network) {
        this.share(network)
    }

    /**
     * Shares URL in specified network.
     */
    share(network){
        this.resizePopup()

        // If a popup window already exist, we close it and trigger a change event.
        if (this.popup.window && this.popup.interval) {
            clearInterval(this.popup.interval)

            // Force close (for Facebook)
            this.popup.window.close()
        }

        this.popup.window = window.open(
            this.networks[network],
            'sharer-' + '_blank',
            ',height=' + this.popupProps.height +
            ',width=' + this.popupProps.width +
            ',left=' + this.popup.left +
            ',top=' + this.popup.top +
            ',screenX=' + this.popup.left +
            ',screenY=' + this.popup.top
        )

        // If popup are prevented (AdBlocker, Mobile App context..), popup.window stays undefined and we can't display it
        if (!this.popup.window) {
            this.touch(network)
            return
        }

        this.popup.window.focus()
        // Create an interval to detect popup closing event
        this.popup.interval = setInterval(() => {
            if (!this.popup.window || this.popup.window.closed) {
                clearInterval(this.popup.interval)

                this.popup.window = null
            }
        }, 500)
    }

    /**
     * Touches network and emits click event.
     */
    touch(network) {
        window.open(this.networks[network], '_blank')
    }

}

export default SocialShare
